import { VueModule } from '@Foundation/utilities';
import SmileyVote from './code/Scripts/components/smiley-vote';

export default VueModule({
  components: {
    SmileyVote
  }
});
